import { render, staticRenderFns } from "./VasionGaugeChart.vue?vue&type=template&id=5ba91bdb&scoped=true&"
import script from "./VasionGaugeChart.vue?vue&type=script&lang=js&"
export * from "./VasionGaugeChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba91bdb",
  null
  
)

export default component.exports